import axios from 'axios';

import { IRequestConfig, MethodsTypes } from 'models/Axios';
import Services from './index.service';
export default class HolidayService extends Services<any, any> {

  getHoliday = async (cod: string) => {
    const config: IRequestConfig<any> = {
      url: `${this.base_url}/holiday/holiday-year`,
      method: MethodsTypes.get,
      headers: {
        "Content-Type": "application/json",
        "token": cod
      },
    };

    const request = await axios(config)
      .then((result) => result);

    if (request.status !== 200)
      return false;

    return request.data;
  };
}